import { QueryClient } from '@tanstack/react-query';

export const OPERATOR_TASKS_KEY = 'operatorTasks';

// Invalidate rather than refetch: the launchpad read is disabled while the member refetches, and
// refetchQueries skips disabled queries, so the read would stay stale. Invalidated, it refetches once enabled.
export function invalidateOperatorTasksQueries(queryClient: QueryClient) {
    return queryClient.invalidateQueries({ queryKey: [OPERATOR_TASKS_KEY] });
}
